export enum FruizioneEnum {
    'Bicicletta da strada' = 1,
    'Bicicletta elettrica',
    'Bicicletta ibrida',
    'Mountain biking',
    'Nordic Walking',
    'Trekking',
    'Turismo equestre',
}
